<template>
  <div class="sb-filter">
        <!-- Titlen tegnes af indpakningen, som også bærer sammenklapningen. -->
    <div class="sb-filter__toggle-group">
      <button type="button"
              class="sb-filter__btn"
              :class="{ 'sb-filter__btn--active': selectedValue === 'yes' }"
              @click="setValue('yes')">
        Ja
      </button>
      <button type="button"
              class="sb-filter__btn sb-filter__btn--neutral"
              :class="{ 'sb-filter__btn--active': selectedValue === '' }"
              @click="setValue('')">
        –
      </button>
      <button type="button"
              class="sb-filter__btn"
              :class="{ 'sb-filter__btn--active': selectedValue === 'no' }"
              @click="setValue('no')">
        Nej
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { alleAktiveFiltre } from '@/Components/FilterManager.vue';

const props = defineProps<{ filter: any; urlParams: URLSearchParams, categoryName: string }>();
const emit = defineEmits(['filterUpdated']);

const getInitialValue = () => {
  const param = props.urlParams.get(String(props.filter.id));
  if (param === 'yes' || param === 'no') return param;
  return '';
};

const selectedValue = ref(getInitialValue());

watch(
  () => props.urlParams.get(String(props.filter.id)),
  (newVal) => {
    if (newVal === 'yes' || newVal === 'no') {
      selectedValue.value = newVal;
    } else {
      selectedValue.value = '';
    }
  }
);

function setValue(val: string) {
  if (selectedValue.value === val) {
    selectedValue.value = '';
  } else {
    selectedValue.value = val;
  }
  emitUpdate();
}

function emitUpdate() {
  if (selectedValue.value === '') {
    /*
     * ALLE aktive filtre sendes med, ikke kun lagerfilteret.
     *
     * updateQueryParamsAndReload sletter enhver parameter der ikke står i
     * listen. Lagerfilteret findes i HVER kategori, så et klik på "kun på
     * lager" ryddede socket, kapacitet og alt andet brugeren havde valgt.
     * Det er præcis den slags der får en nørd til at give op.
     */
    emit('filterUpdated', alleAktiveFiltre(props.urlParams, props.filter.id, ''));
    return;
  }

  emit('filterUpdated', alleAktiveFiltre(props.urlParams, props.filter.id, selectedValue.value));
}
</script>

<style scoped>
.sb-filter__title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--pc-text-primary);
  margin-bottom: 0.5rem;
  text-transform: capitalize;
}

.sb-filter__toggle-group {
  display: inline-flex;
  border-radius: var(--pc-radius);
  overflow: hidden;
  border: 1px solid var(--pc-border);
  background: var(--pc-bg-tertiary);
}

.sb-filter__btn {
  padding: 0.4rem 0.9rem;
  font-size: var(--pc-text-sm);
  font-weight: 500;
  color: var(--pc-text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--pc-transition);
  line-height: 1.2;
  min-width: 44px;
  text-align: center;
}

.sb-filter__btn--neutral {
  border-left: 1px solid var(--pc-border);
  border-right: 1px solid var(--pc-border);
}

.sb-filter__btn:hover:not(.sb-filter__btn--active) {
  background: var(--pc-bg-hover);
  color: var(--pc-text-primary);
}

.sb-filter__btn--active {
  background: var(--pc-accent);
  color: var(--pc-bg-primary);
  font-weight: 600;
}
</style>
